module.exports = __webpack_public_path__ + "img/logo-nav.db57b9bb.png";